<ion-header
  class="ion-no-border my-orders-filters_header"
  [ngClass]="
    (platformService?.isTouchExperience$ | async)
      ? 'ion-header-modal-tablet'
      : 'ion-header-modal-desktop'
  "
>
  <ion-toolbar>
    <ion-buttons
      *ngIf="(platformService?.isTouchExperience$ | async) === false"
      slot="end"
    >
      <ion-button data-cy="close-modal-btn" (click)="dismissModal()">
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-label>{{ 'i18n.orderStatusPage.filter' | translate }} </ion-label>
    <ion-badge *ngIf="selectedFiltersSummary['total']">
      {{ selectedFiltersSummary['total'] }}
    </ion-badge>
  </ion-toolbar>
</ion-header>

<ion-content
  class="my-orders-filters_content"
  [ngClass]="
    (platformService?.isTouchExperience$ | async)
      ? 'ion-content-modal-tablet'
      : 'ion-content-modal-desktop'
  "
  [scrollY]="true"
  tabletTouchMove
>
  <form
    *ngIf="!!formValue"
    [formGroup]="filtersFormGroup"
    (ngSubmit)="dismissModal(true)"
  >
    <ion-grid>
      <ion-row>
        <!-- Filter Options -->
        <ion-col size="5" class="my-orders-filters-options">
          <ion-list>
            <ion-item
              *ngFor="let filterKey of getFiltersKeys()"
              [class.selected]="selectedFilter === filterKey"
              detail
              (click)="setSelectedFilter(filterKey)"
            >
              <ion-label
                [ngClass]="
                  selectedFilter === filterKey ? 'selected-filter-label' : ''
                "
                translate
              >
                {{ filters[filterKey].displayName }}
                <span
                  *ngIf="
                    selectedFiltersSummary[filterKey] !== undefined &&
                    filterKey !== 'deliveryDate'
                  "
                >
                  {{ 'i18n.orderStatusPage.selected' | translate }}:
                  {{ selectedFiltersSummary[filterKey] }}
                </span>
                <span
                  *ngIf="
                    selectedFiltersSummary[filterKey] !== undefined &&
                    filterKey === 'deliveryDate'
                  "
                >
                  {{ selectedFiltersSummary[filterKey] }}
                </span>
              </ion-label>
            </ion-item>
          </ion-list>
        </ion-col>
        <!-- Filter Selections -->
        <ion-col offset="1.5" size="5.5" class="my-orders-filters-input">
          <!-- Order Status -->
          <!-- Remember My Selection Toggle for Order Status -->
          <ng-container *ngIf="selectedFilter === 'orderStatus'">
            <ng-container
              *appShowSplit="[
                features.split_global_order_status_filter_defaults.name,
              ]"
            >
              <div class="remember-my-selection-toggle-container">
                <ion-label
                  [class.active-selection]="
                    selectedFiltersSummary['orderStatus'] > 0
                  "
                  >{{
                    'i18n.orderStatusPage.rememberMySelection' | translate
                  }}</ion-label
                >
                <ion-toggle formControlName="rememberOrderStatus"></ion-toggle>
              </div>
            </ng-container>
          </ng-container>

          <div
            *ngIf="selectedFilter === 'orderStatus'"
            formGroupName="orderStatus"
          >
            <ion-list>
              <ion-item
                *ngFor="
                  let filter of filters[selectedFilter].value
                    | keyvalue: mapOrder
                "
              >
                <ion-checkbox
                  class="order-status-checkbox"
                  mode="ios"
                  slot="end"
                  [formControlName]="$any(filter.key)"
                >
                  {{ $any(filter.value) | titlecase }}
                </ion-checkbox>
              </ion-item>
            </ion-list>
          </div>

          <!-- Customers -->
          <!-- Remember My Selection Toggle for Customers -->
          <ng-container *ngIf="selectedFilter === 'customers'">
            <ng-container
              *appShowSplit="[
                features.split_global_order_status_filter_defaults.name,
              ]"
            >
              <div class="remember-my-selection-toggle-container">
                <ion-label
                  [class.active-selection]="
                    selectedFiltersSummary['customers'] > 0
                  "
                  >{{
                    'i18n.orderStatusPage.rememberMySelection' | translate
                  }}</ion-label
                >
                <ion-toggle formControlName="rememberCustomers"></ion-toggle>
              </div>
            </ng-container>
          </ng-container>

          <div *ngIf="selectedFilter === 'customers'" formGroupName="customers">
            <ion-searchbar
              *ngIf="filters[selectedFilter].searchable"
              id="customers-searchbar"
              data-cy="customers-searchbar"
              class="search"
              mode="md"
              placeholder="{{ 'i18n.common.searchCustomers' | translate }}"
              (ionClear)="clearCustomerSearch()"
              (ionInput)="searchCustomer($event)"
            ></ion-searchbar>
            <ion-list class="customers-list">
              <ng-container *ngFor="let filter of searchedCustomers">
                <ion-item
                  class="customer"
                  [class.has-dept]="
                    filter.departments && filter.departments?.length > 0
                  "
                >
                  <ion-badge slot="start">
                    {{ getFirstLetter(filter.customerName) }}
                  </ion-badge>

                  <ng-container
                    *ngIf="filter.departments && filter.departments?.length > 0"
                  >
                    <ion-label>
                      {{ filter.customerName | titlecase }}<br />({{
                        filter.customerNumber
                      }})
                      <span>
                        {{ filter.city | titlecase }}, {{ filter.state }}
                      </span>
                    </ion-label>
                  </ng-container>
                  <ion-checkbox
                    *ngIf="
                      !filter.departments || filter.departments?.length === 0
                    "
                    mode="ios"
                    slot="end"
                    [formControlName]="filter.customerNumber"
                    class="filter-checkbox"
                  >
                    <span class="customer-name-filter_text">
                      {{ filter.customerName | titlecase }}
                    </span>
                    <br class="break-line" />
                    <span>({{ filter.customerNumber }})</span>
                    <br />
                    <span class="city-name-filter_text">
                      {{ filter.city | titlecase }}, {{ filter.state }}
                    </span>
                  </ion-checkbox>
                </ion-item>
                <ng-container
                  *ngIf="filter.departments && filter.departments?.length > 0"
                >
                  <ion-item
                    *ngFor="let dept of filter.departments"
                    [formGroupName]="filter.customerNumber"
                    class="dept"
                  >
                    <ion-checkbox
                      mode="ios"
                      slot="end"
                      [formControlName]="dept.departmentNumber"
                      class="filter-checkbox"
                    >
                      {{ dept.departmentName | titlecase }}&nbsp;({{
                        dept.departmentNumber
                      }})
                    </ion-checkbox>
                  </ion-item>
                </ng-container>
              </ng-container>
              <div
                *ngIf="searchedCustomers.length === 0"
                class="no-customers-found"
              >
                {{ 'i18n.orderStatusPage.noCustomersFound' | translate }}
              </div>
            </ion-list>
          </div>

          <!-- Delivery Date -->
          <div *ngIf="selectedFilter === 'deliveryDate'">
            <mat-card>
              <div class="delivery-date-info">
                <ion-icon name="calendar-outline"></ion-icon>
                <span class="date-range">
                  {{ 'i18n.orderStatusPage.dateRange' | translate }}:&nbsp;
                </span>
                <span *ngIf="selectedRangeValue?.start" class="date">
                  {{ selectedRangeValue.start.format('M/D/YYYY') }}
                </span>
                <span
                  *ngIf="!selectedRangeValue?.start"
                  class="date-placeholder"
                >
                  {{ 'i18n.orderStatusPage.datePlaceholder' | translate }}
                </span>
                <span>&nbsp;-&nbsp;</span>
                <span *ngIf="selectedRangeValue?.end" class="date">
                  {{ selectedRangeValue.end.format('M/D/YYYY') }}
                </span>
                <span *ngIf="!selectedRangeValue?.end" class="date-placeholder">
                  {{ 'i18n.orderStatusPage.datePlaceholder' | translate }}
                </span>
              </div>
              <mat-calendar
                #calendar
                [minDate]="minCalendarDate"
                [selected]="selectedRangeValue"
                (selectedChange)="selectedDateRangeChange($event)"
              >
              </mat-calendar>
            </mat-card>
            <ng-container
              *appShowSplit="[
                features.split_global_order_status_filter_defaults.name,
              ]"
            >
              <div
                class="date-presets-container"
                data-cy="date-presets-container"
                formGroupName="deliveryDate"
              >
                <div class="date-presets-header" data-cy="date-presets-header">
                  {{ 'i18n.orderStatusPage.selectPreset' | translate }}
                </div>
                <div
                  class="date-presets-buttons"
                  data-cy="date-presets-buttons"
                >
                  <button
                    type="button"
                    class="preset-button"
                    [ngClass]="{ active: activePreset === DatePreset.Today }"
                    (click)="selectPreset(DatePreset.Today)"
                    data-cy="preset-today"
                  >
                    {{ 'i18n.orderStatusPage.today' | translate }}
                  </button>
                  <button
                    type="button"
                    class="preset-button"
                    [ngClass]="{ active: activePreset === DatePreset.Tomorrow }"
                    (click)="selectPreset(DatePreset.Tomorrow)"
                    data-cy="preset-tomorrow"
                  >
                    {{ 'i18n.orderStatusPage.tomorrow' | translate }}
                  </button>
                  <button
                    type="button"
                    class="preset-button"
                    [ngClass]="{ active: activePreset === DatePreset.TwoDays }"
                    (click)="selectPreset(DatePreset.TwoDays)"
                    data-cy="preset-2days"
                  >
                    {{ 'i18n.orderStatusPage.twoDays' | translate }}
                  </button>
                  <button
                    type="button"
                    class="preset-button"
                    [ngClass]="{
                      active: activePreset === DatePreset.ThreeDays,
                    }"
                    (click)="selectPreset(DatePreset.ThreeDays)"
                    data-cy="preset-3days"
                  >
                    {{ 'i18n.orderStatusPage.threeDays' | translate }}
                  </button>
                  <button
                    type="button"
                    class="preset-button"
                    [ngClass]="{ active: activePreset === DatePreset.OneWeek }"
                    (click)="selectPreset(DatePreset.OneWeek)"
                    data-cy="preset-1week"
                  >
                    {{ 'i18n.orderStatusPage.oneWeek' | translate }}
                  </button>
                  <button
                    type="button"
                    class="preset-button"
                    [ngClass]="{ active: activePreset === DatePreset.TwoWeeks }"
                    (click)="selectPreset(DatePreset.TwoWeeks)"
                    data-cy="preset-2weeks"
                  >
                    {{ 'i18n.orderStatusPage.twoWeeks' | translate }}
                  </button>
                  <button
                    type="button"
                    class="preset-button"
                    [ngClass]="{
                      active: activePreset === DatePreset.ThreeWeeks,
                    }"
                    (click)="selectPreset(DatePreset.ThreeWeeks)"
                    data-cy="preset-3weeks"
                  >
                    {{ 'i18n.orderStatusPage.threeWeeks' | translate }}
                  </button>
                </div>
                <div
                  class="save-preset-container"
                  [class.disabled-toggle-container]="
                    rememberDeliveryDatePresetControl.disabled
                  "
                  data-cy="save-preset-container"
                >
                  <span data-cy="save-preset-label">{{
                    'i18n.orderStatusPage.rememberDeliveryDatePreset'
                      | translate
                  }}</span>
                  <ion-toggle
                    [formControl]="rememberDeliveryDatePresetControl"
                    data-cy="save-preset-toggle"
                  ></ion-toggle>
                </div>
              </div>
            </ng-container>
          </div>

          <!-- Delivery Method -->
          <!-- Remember My Selection Toggle for Delivery Method -->
          <ng-container *ngIf="selectedFilter === 'deliveryMethod'">
            <ng-container
              *appShowSplit="[
                features.split_global_order_status_filter_defaults.name,
              ]"
            >
              <div class="remember-my-selection-toggle-container">
                <ion-label
                  [class.active-selection]="
                    selectedFiltersSummary['deliveryMethod'] > 0
                  "
                  >{{
                    'i18n.orderStatusPage.rememberMySelection' | translate
                  }}</ion-label
                >
                <ion-toggle
                  formControlName="rememberDeliveryMethod"
                ></ion-toggle>
              </div>
            </ng-container>
          </ng-container>

          <div
            *ngIf="selectedFilter === 'deliveryMethod'"
            formGroupName="deliveryMethod"
          >
            <ion-list>
              <ion-item
                *ngFor="
                  let filter of filters[selectedFilter].value
                    | keyvalue: mapOrder
                "
              >
                <ion-checkbox
                  mode="ios"
                  slot="end"
                  [formControlName]="$any(filter.key)"
                  class="filter-checkbox"
                >
                  {{ $any(filter.value) }}
                </ion-checkbox>
              </ion-item>
            </ion-list>
          </div>

          <!-- Seller/TM -->
          <div *ngIf="selectedFilter === 'seller'" formGroupName="seller">
            <ng-container *appShowSplit="[sellerFilterFeatureFlag]">
              <ion-searchbar
                id="seller-searchbar"
                data-cy="seller-searchbar"
                class="search"
                mode="md"
                placeholder="{{ 'i18n.common.search' | translate }}"
                (ionClear)="clearSellerSearch()"
                (ionInput)="searchSeller($event)"
              ></ion-searchbar>

              <ion-list class="seller-list">
                <ion-item lines="none" class="no-border">
                  <ion-checkbox
                    *ngIf="!!searchedSellers?.length"
                    labelPlacement="end"
                    [indeterminate]="isAnySellerSelected()"
                    mode="ios"
                    slot="start"
                    (ionChange)="selectAllSellers($event.detail.checked)"
                    [checked]="isAllSellersSelected()"
                  >
                    <span class="select-all-text">
                      {{ 'i18n.orderStatusPage.selectAll' | translate }}</span
                    >
                  </ion-checkbox>
                </ion-item>
                <hr class="divider" />

                <!-- Sellers with expandable sections -->
                <div
                  *ngFor="let seller of searchedSellers"
                  class="seller-section"
                >
                  <div
                    class="seller-header"
                    (click)="toggleSellerExpanded(seller.id)"
                  >
                    <div class="seller-header-content">
                      <ion-checkbox
                        [indeterminate]="isSellerHeaderIndeterminate(seller.id)"
                        [checked]="isSellerHeaderChecked(seller.id)"
                        mode="ios"
                        slot="start"
                        [value]="seller.id"
                        (ionChange)="
                          sellerHeaderCheckboxChange($event, seller.id)
                        "
                        (click)="$event.stopPropagation()"
                      >
                      </ion-checkbox>
                      <div>
                        <span class="main-name"
                          >{{ seller.name }} <br />
                          ({{ seller.tmId }})</span
                        >
                        <br />
                        <span class="sub-name">{{ seller.salesRoute }}</span>
                      </div>
                    </div>
                    <ion-icon
                      detail
                      slot="end"
                      [name]="
                        isSellerExpanded(seller.id)
                          ? 'chevron-up'
                          : 'chevron-down'
                      "
                    >
                    </ion-icon>
                  </div>

                  <!-- Customer items under each seller, shown when expanded -->
                  <div
                    class="seller-customers"
                    [class.expanded]="isSellerExpanded(seller.id)"
                  >
                    <div *ngFor="let customer of seller.customers">
                      <div class="customer-item">
                        <ion-checkbox
                          *ngIf="
                            customer.departments &&
                            customer.departments.length === 0
                          "
                          mode="ios"
                          slot="start"
                          [value]="customer.id"
                          [formControlName]="seller.id + '_' + customer.id"
                        >
                        </ion-checkbox>
                        <ion-checkbox
                          *ngIf="
                            customer.departments &&
                            customer.departments.length > 0
                          "
                          mode="ios"
                          slot="start"
                          [indeterminate]="
                            isCustomerHeaderIndeterminate(
                              seller.id,
                              customer.id
                            )
                          "
                          [checked]="
                            isCustomerHeaderChecked(seller.id, customer.id)
                          "
                          (ionChange)="
                            customerHeaderCheckboxChange(
                              $event,
                              seller.id,
                              customer.id
                            )
                          "
                          (click)="$event.stopPropagation()"
                        >
                        </ion-checkbox>
                        <div>
                          <span class="main-name"
                            >{{ customer.name }}
                            <br />
                            {{ customer.subtitle }}
                            <br />
                            <span class="city-name-filter_text">
                              {{ customer.city | titlecase }},
                              {{ customer.state }}
                            </span>
                          </span>
                        </div>
                      </div>

                      <div
                        class="customer-dept-item"
                        *ngIf="
                          customer.departments &&
                          customer.departments.length > 0
                        "
                      >
                        <ion-item
                          lines="none"
                          class="no-border"
                          *ngFor="
                            let dept of customer.departmentNumbers;
                            let i = index
                          "
                          [formGroupName]="seller.id + '_' + customer.id"
                        >
                          <ion-checkbox
                            mode="ios"
                            slot="start"
                            [formControlName]="dept"
                          >
                          </ion-checkbox>
                          <span class="main-name">
                            {{ customer.departments[i] | titlecase }}&nbsp;({{
                              dept
                            }})
                          </span>
                        </ion-item>
                      </div>
                    </div>
                  </div>
                </div>
              </ion-list>
            </ng-container>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
  </form>
</ion-content>

<ion-footer
  class="ion-footer-modal"
  [class.ion-footer-modal-desktop]="
    (platformService?.isTouchExperience$ | async) === false
  "
>
  <ion-toolbar>
    <ion-buttons>
      <ion-button
        id="clear-all-modal-btn"
        data-cy="clear-all-modal-btn"
        class="usf-outline-green-dsktp-tblt-modal-button"
        (click)="resetFilters()"
        translate
      >
        {{ 'i18n.common.clearAll' }}
      </ion-button>
      <ion-button
        id="apply-modal-btn"
        data-cy="apply-modal-btn"
        class="usf-fill-green-dsktp-tblt-modal-button"
        [disabled]="hasIncompleteDateRange"
        (click)="dismissModal(true)"
        translate
      >
        {{ 'i18n.common.apply' }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
